import React, { Component } from 'react';
import { Line } from 'react-chartjs-2';

class CreatedLinksChart extends Component {
  renderData = () => {
    const { labels, data } = this.props.link_stat;
    return {
      labels: labels,
      datasets: [
        {
          lineTension: 0.1,
          backgroundColor: '#fff',
          borderColor: 'grey',
          borderWidth: 1,
          data: data,
        },
      ],
    };
  };

  renderOptions = () => {
    return {
      legend: {
        display: false,
      },
      elements: {
        point: { radius: 0 },
      },
      scales: {
        xAxes: [
          {
            ticks: {
              display: false,
            },
            gridLines: {
              drawOnChartArea: false,
              color: 'rgba(0, 0, 0, 0)',
            },
          },
        ],
        yAxes: [
          {
            type: 'linear',
            display: true,
            id: 'y-axis-1',
            ticks: {
              display: false,
              suggestedMax: 30,
              reverse: false,
            },
            gridLines: {
              drawBorder: false,
              color: 'rgba(0, 0, 0, 0)',
              zeroLineColor: 'transparent',
            },
          },
        ],
      },
    };
  };

  render() {
    return (
      <div className="link-itm__chartWrapper">
        <Line
          data={this.renderData()}
          options={this.renderOptions()}
          height={60}
        />
      </div>
    );
  }
}

export default CreatedLinksChart;



// WEBPACK FOOTER //
// ./src/components/CreatedLinksChart/CreatedLinksChart.js